import React, { useMemo } from "react";

function toInt(v){ const n=parseInt(String(v||"").replace(/[^\d]/g,""),10); return Number.isFinite(n)?n:1; }
function toFloat(v){ const s=String(v||"").replace(/\s/g,"").replace(",","."); const cl=s.replace(/[^0-9.]/g,""); const p=cl.split("."); const n=parseFloat(p.length>2?`${p[0]}.${p.slice(1).join("")}`:cl); return Number.isFinite(n)?n:0; }
const sym = (c)=> (c==="USD"?"US$":"$");
const ivaPct = (r)=> ((r*100)%1===0?Math.round(r*100):+(r*100).toFixed(1));
const lineDiscount = (r)=>{
  const base = Number(r.qty||0)*Number(r.price||0);
  const value = Math.max(0, Number(r.discount)||0);
  const type = r.discount_type || "percentage";
  return type === "fixed" ? Math.min(base, value) : Math.min(base, base * (value / 100));
};
const lineNet = (r)=> Math.max(0, Number(r.qty||0)*Number(r.price||0) - lineDiscount(r));

export default function ServiceEditor({ currency="ARS", ivaRate=0.21, rows, onChange }) {
  const grossSubtotal = useMemo(()=> rows.reduce((s,r)=> s + Number(r.qty||0)*Number(r.price||0),0), [rows]);
  const discountTotal = useMemo(()=> rows.reduce((s,r)=> s + lineDiscount(r),0), [rows]);
  const subtotal = useMemo(()=> rows.reduce((s,r)=> s + lineNet(r),0), [rows]);
  const tax = +(subtotal*ivaRate).toFixed(2);
  const total = +(subtotal+tax).toFixed(2);

  const setRow = (idx, value)=>{
    const next=[...rows]; next[idx]=value; onChange(next);
  };
  const addRow = ()=>{
    onChange([ ...rows, { order:(rows[rows.length-1]?.order||rows.length)+1, description:"", qty:1, price:0, discount:0, discount_type:"percentage" } ]);
  };
  const removeRow = (idx)=> onChange(rows.filter((_,i)=> i!==idx));

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h4 className="text-sm font-semibold">Servicios</h4>
        <button type="button" className="rounded-xl bg-emerald-600 text-white px-3 py-1.5 hover:bg-emerald-700"
                onClick={addRow}>+ Agregar servicio</button>
      </div>

      <div className="space-y-3">
        {rows.map((r, idx)=>(
          <div key={idx} className="grid grid-cols-12 gap-2 items-center rounded-xl border border-border/60 bg-muted/5 p-3">
            <div className="col-span-2 md:col-span-1">
              <label className="mb-1 block text-xs text-muted-foreground">Orden</label>
              <input className="w-full h-10 rounded-lg border border-border bg-background px-3 text-right"
                     inputMode="numeric" value={r.order}
                     onChange={e=> setRow(idx, { ...r, order: Math.max(1,toInt(e.target.value)) })}/>
            </div>
            <div className="col-span-12 md:col-span-6">
              <label className="mb-1 block text-xs text-muted-foreground">Descripción</label>
              <input className="w-full h-10 rounded-lg border border-border bg-background px-3"
                     placeholder="Descripción del servicio"
                     value={r.description}
                     onChange={e=> setRow(idx, { ...r, description: e.target.value })}/>
            </div>
            <div className="col-span-6 md:col-span-1">
              <label className="mb-1 block text-xs text-muted-foreground">Cant.</label>
              <input className="w-full h-10 rounded-lg border border-border bg-background px-3 text-right"
                     inputMode="numeric" value={r.qty}
                     onChange={e=> setRow(idx, { ...r, qty: Math.max(1,toInt(e.target.value)) })}/>
            </div>
            <div className="col-span-6 md:col-span-2">
              <label className="mb-1 block text-xs text-muted-foreground">Precio unitario</label>
              <input className="w-full h-10 rounded-lg border border-border bg-background px-3 text-right"
                     inputMode="decimal" placeholder="0"
                     value={r.price_raw ?? (r.price ?? 0)}
                     onChange={e=> { const raw=e.target.value; const val=toFloat(raw); setRow(idx,{...r, price:val, price_raw:raw}); }}
                     onBlur={e=> { const val=toFloat(e.target.value); setRow(idx,{...r, price:val, price_raw:val.toFixed(2)}); }}/>
            </div>
            <div className="col-span-6 md:col-span-1">
              <label className="mb-1 block text-xs text-muted-foreground">Desc.</label>
              <input className="w-full h-10 rounded-lg border border-border bg-background px-3 text-right"
                     inputMode="decimal" placeholder="0"
                     value={r.discount_raw ?? (r.discount ?? 0)}
                     onChange={e=> {
                       const raw=e.target.value;
                       const val=toFloat(raw);
                       const safeVal=(r.discount_type || "percentage")==="percentage" ? Math.min(100,val) : val;
                       setRow(idx,{...r, discount:safeVal, discount_raw:raw});
                     }}
                     onBlur={e=> {
                       const val=toFloat(e.target.value);
                       const safeVal=(r.discount_type || "percentage")==="percentage" ? Math.min(100,val) : val;
                       setRow(idx,{...r, discount:safeVal, discount_raw:safeVal.toFixed(2)});
                     }}/>
            </div>
            <div className="col-span-6 md:col-span-1">
              <label className="mb-1 block text-xs text-muted-foreground">Tipo desc.</label>
              <select className="w-full h-10 rounded-lg border border-border bg-background px-2"
                      value={r.discount_type || "percentage"}
                      onChange={e=> {
                        const nextType=e.target.value;
                        const current=Number(r.discount)||0;
                        setRow(idx,{...r, discount_type:nextType, discount:nextType==="percentage"?Math.min(100,current):current});
                      }}>
                <option value="percentage">%</option>
                <option value="fixed">{sym(currency)}</option>
              </select>
            </div>
            <div className="col-span-12 flex flex-col gap-2 border-t border-border/40 pt-2 sm:flex-row sm:items-end sm:justify-between">
              <button type="button" className="rounded-xl bg-rose-600 text-white px-3 py-1.5 hover:bg-rose-700"
                      onClick={()=>removeRow(idx)}>Eliminar</button>
              <div className="flex flex-col gap-0.5 text-right text-sm font-medium">
                <div>Subtotal bruto: {sym(currency)}{(Number(r.qty||0)*Number(r.price||0)).toFixed(2)}</div>
                {lineDiscount(r) > 0 && (
                  <div className="text-orange-400">
                    Desc. ítem: - {sym(currency)}{lineDiscount(r).toFixed(2)}
                  </div>
                )}
                <div className="text-base font-semibold">Total ítem: {sym(currency)}{lineNet(r).toFixed(2)}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-12 gap-3 mt-2">
        <div className="col-span-12 sm:col-span-4">
          <div className="rounded-xl border border-border p-3 bg-muted/10">
            <div className="text-xs text-muted-foreground">Subtotal bruto</div>
            <div className="text-lg font-semibold">{sym(currency)}{grossSubtotal.toFixed(2)}</div>
          </div>
        </div>
        <div className="col-span-12 sm:col-span-4">
          <div className="rounded-xl border border-border p-3 bg-muted/10">
            <div className="text-xs text-muted-foreground">Descuentos por ítem</div>
            <div className="text-lg font-semibold text-orange-400">- {sym(currency)}{discountTotal.toFixed(2)}</div>
          </div>
        </div>
        <div className="col-span-12 sm:col-span-4">
          <div className="rounded-xl border border-border p-3 bg-muted/10">
            <div className="text-xs text-muted-foreground">Subtotal ítems + IVA ({ivaPct(ivaRate)}%)</div>
            <div className="text-lg font-semibold">{sym(currency)}{total.toFixed(2)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
